import CircleAlert from '@/common/assets/icons/criceleAlert.svg?react';
import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import { ConfirmDriverModalProps } from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/ConfirmDriver.type';
import React from 'react';
import { Box, Flex } from 'styled-system/jsx';

const ConfirmDriverModal: React.FC<ConfirmDriverModalProps> = ({
  setOpenModal,
  open,
  navigateTo,
  cancelNavigate,
}) => {
  const handleClose = () => {
    cancelNavigate();
    setOpenModal(false);
  };
  return (
    <MainModal open={open} closeModal={() => setOpenModal(false)}>
      <Flex direction="column" gap={32}>
        <Box w="100%" display="flex" justifyContent="center">
          <CircleAlert />
        </Box>
        <Typography textStyle="b1" color="black-1">
          کارشناس عزیز، به منظور تکمیل اطلاعات لازم است مشخصات مالک را هم وارد
          کنید.
        </Typography>
        <Flex justifyContent="space-between" gap={8}>
          <Button variant="outlined" fullWidth onClick={handleClose}>
            بعدا ثبت می‌کنم
          </Button>
          <Button onClick={navigateTo} fullWidth>
            ثبت مشخصات
          </Button>
        </Flex>
      </Flex>
    </MainModal>
  );
};
export default ConfirmDriverModal;
